module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("MmBoY"))).then(() => parcelRequire('ljYL6'));